import { Path, Rect, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M14 8H21M14 12H21M14 16H21" />
		<Rect x="3" y="6" width="8" height="12" fill="currentColor" stroke="none" />
	</SVG>
);
